const SharedData = {
    sid: 0,
    workActionAreaId: null,
    workActionSubareaId: null,
    workServiceId: null,
}

export const Consumption = {
    new: () => {
        return {
            ...SharedData,
            consumable: null,
            quantity: 0,
            notes: '',
            owner_id: 0,
        };
    },
    fullTitle: (consumption) => {
        let title = consumption.consumable?.category?.name ?? '?';
        title += ' - ' + (consumption.consumable?.name ?? '?');
        return title;
    },
    displayQuantity: (consumption) => {
        let displayQuantity = consumption.quantity + (consumption.consumable?.unit || '');
        return displayQuantity;
    }
};

export const Employee = {
    new: () => {
        return {
            ...SharedData,
            name: '',
            hours: 0,
            notes: '',
            owner: 0,
            isResponsable: false,
            exclude_from_billing: false
        };
    },
    findEmployeeById: (planning, id) => {
        // console.debug(planning, id);
        // Check planning and employees exists
        if (!planning || !planning.staff) {
            return null;
        }
        // console.debug(planning.staff);

        return planning.staff.find((employee) => employee.id === id);
    },
    fullTitle: (employee, planning = null, defaultTitle = '?') => {
        let title = defaultTitle;
        if (employee.name) {
            title = '' + employee.name;
        } else if (employee.staff_id && planning) {
            let staff = Employee.findEmployeeById(planning, employee.staff_id);
            title = '' + (staff?.full_name || '');
        }

        return title;
    },
    displayHours: (employee) => {
        const sufix = 'h';
        if (typeof employee.hours === 'string') {
            return employee.hours + sufix;
        }
        let displayHours = employee.hours?.toFixed(2) + sufix;
        return displayHours;
    }
}

export const Extra = {
    new: () => {
        return {
            species_id: null,
            action_id: null,
            status_id: null,
            feet: 0,
            notes: '',
            owner_id: 0,
            workActionAreaId: null,
            workActionSubareaId: null,
        };
    },
}